module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"payment_details":"Детали платежа"},"en":{"payment_details":"Payment details"}}')
  delete Component.options._Ctor
}
